'use client';

import { Button } from '@/components/ui/button';

import React, { useState } from 'react';
import { useTranslations } from 'next-intl';

import useNavigation from '@/lib/hooks/useNavigation';

type Props = {
  productId: string | null;
  storeId: string | null;
  onClick?: () => void;
  btnTitle?: string;
};

const Modal = ({ productId, storeId }: Props) => {
  const { createQueryString } = useNavigation({ justUpdateUrl: true });

  const t = useTranslations('product');
  const [, setProductInfo] = useState<Props>({
    productId: null,
    storeId: null,
  });

  const handleProductInfo = () => {
    setProductInfo({ productId, storeId });
    createQueryString({ productId: `${productId}`, storeId: `${storeId}` });
  };

  return (
    <>
      <Button
        className="w-full text-xs md:text-base"
        rounded-sm={'full'}
        onClick={handleProductInfo}
      >
        {t('add-to-cart')}
      </Button>
    </>
  );
};

export default Modal;
